import React, { useState, useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function InstagramFeed() {
  const { t } = useTranslation();
  const [media, setMedia] = useState([]);
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeed();
  }, []);

  const fetchFeed = async () => {
    try {
      const resp = await axios.get(`${API_URL}/api/instagram/feed?limit=6`);
      setMedia(resp.data.media || []);
      setConnected(resp.data.connected);
    } catch {
      setConnected(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return null;
  if (!connected || media.length === 0) return null;

  return (
    <section className="instagram-feed-section" data-testid="instagram-feed-section">
      <div className="section-header">
        <span className="section-label">{t('instagram.label')}</span>
        <h2 className="section-title">{t('instagram.title')}</h2>
      </div>

      <div className="ig-grid">
        {media.map((item) => (
          <a
            key={item.id}
            href={item.permalink}
            target="_blank"
            rel="noopener noreferrer"
            className="ig-item"
            data-testid={`ig-post-${item.id}`}
          >
            {item.media_type === 'VIDEO' ? (
              <video
                src={item.media_url}
                className="ig-media"
                muted
                loop
                playsInline
                onMouseEnter={(e) => e.target.play()}
                onMouseLeave={(e) => e.target.pause()}
              />
            ) : (
              <img
                src={item.media_url || item.thumbnail_url}
                alt={item.caption ? item.caption.substring(0, 60) : t('instagram.postAlt')}
                className="ig-media"
                loading="lazy"
              />
            )}
            <div className="ig-overlay">
              <ExternalLink className="w-5 h-5" />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

export default InstagramFeed;
